"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormState = void 0;
/**
 * Estado centralizado del formulario.
 * Fuente única de verdad para los datos compartidos entre servicios.
 */
class FormState {
    constructor() {
        this.addressSelected = false;
        this.addressPlace = null;
    }
    setAddress(selected, place) {
        this.addressSelected = selected;
        this.addressPlace = place;
    }
}
exports.FormState = FormState;
